import { EAttachmentType } from '@constants';
import { IAttachment, IFile } from '@sdk/contracts';

import { Upload } from '@/components/Upload';
import { IUpload } from '@/types';

type Props = {
  label?: string;
  files: IFile[];
  onAdd: (value: IAttachment) => void;
  onRemove: (value: IAttachment[]) => void;
};

export const FileAttachment: React.FC<Props> = ({ label, files, onAdd, onRemove }) => {
  const handleUpload = (newUpload: IUpload['value']) => {
    if (!newUpload) {
      onRemove([]);
      return;
    }

    if (Array.isArray(newUpload)) {
      const updatedFiles = newUpload.map(file => ({ type: EAttachmentType.FILE, file }));
      onRemove(updatedFiles as IAttachment[]);
      return;
    }
    onAdd({ type: EAttachmentType.FILE, file: newUpload });
  };

  return (
    <Upload
      block
      label={label}
      value={files}
      mode="upload"
      deleteMode="unlink"
      onChange={handleUpload}
    />
  );
};
